import {Drawer} from '@mantine/core';
import type {GetEntryManagementReturnValueType} from '../../../../../core/repositories/mypageEntryManagementsRepository';
import {
  DRAWER_STYLES_WITH_INTERNAL_SCROLL,
  getDrawerSize,
} from '../../../constants/drawerStyles';
import {Z_INDEX} from '../../../constants/zIndex';
import type {useAiTodoGeneration} from '../../../usecase/useAiTodoGeneration';
import type {useProgressDeleteModal} from '../../../usecase/useProgressDeleteModal';
import {ProgressDetailContainer} from './ProgressDetailContainer';

type Props = {
  entryManagementId: number;
  entryDetailData?: GetEntryManagementReturnValueType;
  existingCompanyNames: string[];
  nextStepName?: string;
  openInputMethodSelectionModal?: () => void;
  aiTodoGeneration?: ReturnType<typeof useAiTodoGeneration>;
  onEditStep?: (stepData: {
    stepId: number;
    stepOrder: number;
    stepName: string;
    deadline: string;
    result: string | null;
    notes: string;
    startDate?: string;
    endDate?: string;
    place?: string;
  }) => void;
  onEditEntryClick: () => void;
  onDeleteClick: () => void;
  onOpenOverallStatusUpdateModal?: () => void;
  onOpenReportAnalyzeModal?: () => void;
  handleOpenDeleteModal: ReturnType<
    typeof useProgressDeleteModal
  >['handleOpenDeleteModal'];
  isSp: boolean;
  opened: boolean;
  onClose: () => void;
  hasTodosForEntryManagement?: (entryManagementId: number) => boolean;
};

/**
 * ProgressDetailContainer をドロワーとして表示するラッパーコンポーネント
 * /mypage/entry_managements/progress でドロワー表示する場合に使用
 */
export const ProgressDetailDrawer: React.FC<Props> = ({
  opened,
  onClose,
  ...containerProps
}) => {
  const {isSp} = containerProps;

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size={getDrawerSize(isSp)}
      zIndex={Z_INDEX.DRAWER}
      styles={DRAWER_STYLES_WITH_INTERNAL_SCROLL}
    >
      <ProgressDetailContainer {...containerProps} />
    </Drawer>
  );
};
